import {
  MaterialResponse,
  MaterialType,
  PurchaseRequestItemType,
} from "../../../types";
import type { ItemRow } from "./types";

/**
 * Fields an item inherits from a material. Extracted verbatim from the pre-Carbon
 * `NewPurchaseRequestV2` page so the material-autocomplete → item-patch behaviour is unit-testable
 * and shared between the composer, the per-item autocomplete, and the just-created-material path
 * without re-deriving the rules in three places.
 *
 * `forcedType` is used right after creating a material: `async: true` means the AI hasn't
 * categorized it yet, so the response carries no category and the requester's Bien/Servicio
 * choice is the authoritative answer.
 */
export const materialPatch = (
  material: MaterialResponse,
  item: ItemRow,
  forcedType?: PurchaseRequestItemType
): Partial<ItemRow> => {
  const itemType =
    forcedType ??
    (material.category?.type === MaterialType.SERVICES
      ? PurchaseRequestItemType.SERVICE
      : PurchaseRequestItemType.GOOD);
  return {
    material: { id: material.id },
    materialEan: material.ean,
    materialName: material.globalMaterialName,
    materialOwnerName: material.owner?.fullName,
    title: item.title || material.globalMaterialName,
    description: item.description || material.brand || material.details || "",
    measurementUnit: item.measurementUnit || material.measurementUnit,
    itemType,
    brand:
      item.brand ??
      (itemType === PurchaseRequestItemType.SERVICE
        ? material.brand || null
        : null),
    site: material.deliveryPlace
      ? { id: material.deliveryPlace.id }
      : (item.site ?? null),
    assignedBuyer: material.owner
      ? { id: material.owner.id }
      : (item.assignedBuyer ?? null),
  };
};
